import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/app-menu/app-menu.js';
      

      export interface Props {
     
   }

      

      
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcAppMenu',
  emits: ["search"],
  setup(__props, { emit: __emit }) {

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onSearch: (event: CustomEvent<string>) => emit('search', event as CustomEvent<string>)
  };
        const props = eventProps as (typeof eventProps & Props);

        

        return h(
          'obc-app-menu',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(render))
}
}

})